import clsx from "classnames";
import classes from "./styles.module.scss";
import Title from "@/ui/Title";
import BackButton from "../BackButton";
import LinkedIn from "@/assets/LinkedIn.svg";
import Phone from "@/assets/Phone.svg";
import Email from "@/assets/Email.svg";
import Body from "@/ui/Body";
import Image from "next/image";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";

export default function ConsultantProfile({ consultant, className = ""}) {

  return (
    <div className={clsx(className, classes.profile)}>
      <div className={classes.hero}>
        <BackButton className={classes.back} link="/meet-our-team" page="Meet Our Team" />
        <div className={classes.content}>
          <div className={classes.left_section}>
            <SourceFlowImage  size="1200x" width="600" height="600" alt={consultant.name} src={consultant.profile_image} className={classes.profile_image} />
            <div className={classes.socials}>
              <a className={classes.social_icon} href={consultant.linkedin} target="_blank" rel="nofollow">
                <LinkedIn width={19} height={19} />
              </a>
              <a className={classes.social_icon} href={`mailto:${consultant.email}`} target="_blank" rel="nofollow">
                <Email width={19} height={19} />
              </a>
              <a className={classes.social_icon} href={"tel:" + consultant.phone} target="_blank" rel="nofollow">
                <Phone width={19} height={19} />
              </a>
            </div>
          </div>
          <div className={classes.right_section}>
            <div className={classes.name}>
              <Title title={consultant.name} tag="h1" className={classes.title} />
              <div className={classes.position}>{consultant.position_title}</div>
              <div className={classes.contact}>
                <div className={classes.icon_cont}><Phone className="fill primary" width={18} height={18} /></div>
                <div>
                  <Body body={consultant.phone} className={classes.value} />
                </div>
              </div>
              <div className={classes.contact}>
                <div className={classes.icon_cont}><Email className="fill primary" width={18} height={18} /></div>
                <div>
                  <Body body={consultant.email} className={classes.value} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.description}>
        <div className={classes.space}>
          <img alt={consultant.name} src={consultant.profile_image} className={classes.profile_image}></img>
        </div>
        <div className={classes.details}>
          <Body body={consultant.description} />
        </div>
      </div>
    </div>
  );
}
